import { SalesAreaPriceLine, useFetchSalesAreaPriceLinesQuery } from "../api/priceLineApi";
import { useAppSelector } from "../../../old/beheer/store";
import { selectSalesAreaId } from "../../SalesAreas/selectors/selectSalesAreaId";
import React, { useMemo } from "react";
import { Collapse, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import _ from "lodash";
import { usePagination } from "../../../old/beheer/views/Upsell/modernTS/JUI/Pagination/usePagination";

export default function SalesAreaPriceLineFilter({
  value,
  onChange,
}: {
  value: SalesAreaPriceLine | undefined;
  onChange: (value: SalesAreaPriceLine | undefined) => void;
}) {
  const salesAreaId = useAppSelector(selectSalesAreaId);
  const pagination = usePagination();

  const { data } = useFetchSalesAreaPriceLinesQuery(
    { salesAreaId: salesAreaId ?? 0, pagination: pagination },
    { skip: salesAreaId == null }
  );

  const mappedValues = useMemo(() => {
    return _.chain(data?.data ?? [])
      .keyBy("id")
      .value();
  }, [data]);

  return (
    <Collapse in={Boolean(salesAreaId) && data ? data.data.length > 0 : null}>
      <FormControl fullWidth>
        <InputLabel id={"Price line"}>Price line</InputLabel>
        <Select
          label={"Price line"}
          onChange={(e) => onChange(e.target.value != null ? mappedValues[e.target.value] : undefined)}
          sx={{
            width: 200,
          }}
          value={value?.id}
        >
          <MenuItem key={"undefined"} value={"undefined"}>
            None
          </MenuItem>
          {data?.data.map((priceLine) => (
            <MenuItem key={priceLine.id} value={priceLine.id}>
              {priceLine.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Collapse>
  );
}
